var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8463 1.57812H4.07707C3.62825 1.57813 3.1978 1.74494 2.88043 2.04187C2.56306 2.33881 2.38477 2.74153 2.38477 3.16146V15.8281C2.38477 16.2481 2.56306 16.6508 2.88043 16.9477C3.1978 17.2446 3.62825 17.4115 4.07707 17.4115H14.2309M10.8463 1.57812L15.9232 6.32812M10.8463 1.57812V6.32812H15.9232M15.9232 6.32812V11.0781M12.5386 10.2865H5.76938M12.5386 13.4531H5.76938M7.46169 7.11979H5.76938",
    stroke: "#6C737F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6326_33839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1926 13.2595V14.645L18.1797 15.1068M19.6605 14.645C19.6605 15.9202 18.5556 16.954 17.1926 16.954C15.8295 16.954 14.7246 15.9202 14.7246 14.645C14.7246 13.3697 15.8295 12.3359 17.1926 12.3359C18.5556 12.3359 19.6605 13.3697 19.6605 14.645Z",
    stroke: "#6C737F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6326_33839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.92308,
    height: 5.54167,
    fill: "white",
    transform: "translate(14.2305 11.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersMore);
export default __webpack_public_path__ + "static/media/users-more.75fa1d510c4b3c12d30fc4a70094bf75.svg";
export { ForwardRef as ReactComponent };